import { Dropdown, DropdownRef, Input, Menu } from '@recruit-robin/robin-theme/web-components';
import { ChevronDown, ChevronUp } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import {
  IndeedProject,
  useIndeedProjectListQuery,
} from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';
import { dropdownCss, menuCss } from './IndeedProjectSelect.styles';

type Props = {
  value: IndeedProject | null;
  onChange: (p: IndeedProject | null) => void;
};

export const IndeedProjectSelect = ({ value, onChange }: Props) => {
  const { dictionary } = useContext(LocalizationContext);
  const dropdownRef = useRef<DropdownRef>(null);
  const [search, setSearch] = useState('');
  const { data: projects = [] } = useIndeedProjectListQuery();

  useEffect(() => {
    if (value === null && projects.length > 0) {
      onChange(projects.find((p) => p.default) ?? projects[0]);
    }
  }, [value, projects, onChange]);

  const filtered = useMemo(
    () => projects.filter((p) => p.name.toLowerCase().includes(search.toLowerCase())),
    [projects, search],
  );

  return (
    <Dropdown
      ref={dropdownRef}
      placement="bottom"
      flipMenu={false}
      shouldUsePortal={false}
      css={dropdownCss}
      renderMenu={
        <Menu.Root customCss={menuCss}>
          {filtered.map((project) => (
            <Menu.Item.Root
              key={project.key}
              selected={value?.key === project.key}
              onClick={() => {
                onChange(project);
                dropdownRef.current?.close();
              }}>
              {project.name}
            </Menu.Item.Root>
          ))}
        </Menu.Root>
      }>
      {({ isOpen }) => (
        <Input
          variant="gray"
          endIcon={isOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          onInput={(e) => setSearch(e.currentTarget.value)}
          placeholder={dictionary.selectAProject}
          value={isOpen ? search : value?.name ?? ''}
          contained
        />
      )}
    </Dropdown>
  );
};
